import { TrendingUp, Youtube, ShoppingCart, Share2 } from "lucide-react"

export function DashboardMockup() {
  const mockData = [
    { platform: "YouTube", amount: 2450, icon: Youtube, color: "text-red-500" },
    { platform: "UpPromote", amount: 1890, icon: ShoppingCart, color: "text-green-500" },
    { platform: "SuperAffiliate", amount: 1250, icon: Share2, color: "text-blue-500" },
    { platform: "Amazon Associates", amount: 980, icon: ShoppingCart, color: "text-orange-500" },
  ]

  return (
    <div className="relative">
      {/* Background glow */}
      <div className="absolute inset-0 bg-gradient-to-r from-green-400/20 to-blue-400/20 blur-3xl rounded-3xl"></div>

      {/* Dashboard mockup */}
      <div className="relative bg-white rounded-2xl shadow-2xl border border-gray-200 p-6 space-y-6">
        {/* Header */}
        <div className="flex items-center justify-between">
          <h3 className="text-lg font-semibold text-gray-900">Earnings by Channel</h3>
          <div className="flex items-center space-x-2 text-green-600">
            <TrendingUp className="h-4 w-4" />
            <span className="text-sm font-medium">+12.5%</span>
          </div>
        </div>

        {/* Chart area placeholder */}
        <div className="h-32 bg-gradient-to-r from-green-50 to-blue-50 rounded-lg flex items-end justify-center space-x-2 p-4">
          {[40, 65, 45, 80, 55, 70, 85].map((height, index) => (
            <div
              key={index}
              className="bg-gradient-to-t from-green-500 to-green-400 rounded-t"
              style={{ height: `${height}%`, width: "12px" }}
            ></div>
          ))}
        </div>

        {/* Earnings table */}
        <div className="space-y-3">
          {mockData.map((item, index) => (
            <div key={index} className="flex items-center justify-between p-3 bg-gray-50 rounded-lg">
              <div className="flex items-center space-x-3">
                <div className={`p-2 rounded-full bg-white ${item.color}`}>
                  <item.icon className="h-4 w-4" />
                </div>
                <span className="font-medium text-gray-900">{item.platform}</span>
              </div>
              <span className="font-semibold text-gray-900">${item.amount.toLocaleString()}</span>
            </div>
          ))}
        </div>

        {/* Total */}
        <div className="border-t pt-4">
          <div className="flex items-center justify-between">
            <span className="text-lg font-semibold text-gray-900">Total Revenue</span>
            <span className="text-2xl font-bold text-green-600">
              ${mockData.reduce((sum, item) => sum + item.amount, 0).toLocaleString()}
            </span>
          </div>
        </div>
      </div>
    </div>
  )
}
